// 💾 src/pages/admin/components/AdminSidebar.tsx
import "./style/AdminSidebar.scss"

type Props = {
  active: string
  setActive: (tab: "dashboard" | "users" | "trades" | "deposits" | "withdrawals" | "settings") => void
}

const AdminSidebar = ({ active, setActive }: Props) => {
  return (
    <aside className="admin-sidebar">
      <h2>Admin Panel</h2>
      <ul>
        <li
          className={active === "dashboard" ? "active" : ""}
          onClick={() => setActive("dashboard")}
        >
          Dashboard
        </li>
        <li
          className={active === "users" ? "active" : ""}
          onClick={() => setActive("users")}
        >
          Users
        </li>
        <li
          className={active === "trades" ? "active" : ""}
          onClick={() => setActive("trades")}
        >
          Trades
        </li>
        <li
        className={active === "deposits" ? "active" : ""}
        onClick={() => setActive("deposits")}
      >
        Deposits
      </li>
        <li
          className={active === "withdrawals" ? "active" : ""}
          onClick={() => setActive("withdrawals")}
        >
          Withdrawals
        </li>
        <li
          className={active === "settings" ? "active" : ""}
          onClick={() => setActive("settings")}
        >
          Settings
        </li>
      </ul>
    </aside>
  )
}

export default AdminSidebar
